<template>
    <div class="list-group">
        <div class="list-group-item">
            <h5 @click="showCard = !showCard" class="mb-0">
                <i :class="cardIcon + ' fa-lg'"></i>
                Kreditkarte hinzufügen
            </h5>
            <add-credit-card
                class="mt-3"
                v-if="stripe !== null && showCard"
                :client-secret="clientSecret"
                :given-customer="customer"
                :stripe="stripe"
                @new-payment-method-created="setNewPaymentMethodAsDefault"
                :submit-active="submitActive"
            ></add-credit-card>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddPaymentMethod",

    props: {
        clientSecret: {
            type: String,
            required: true
        },
        customer: {
            type: Object,
            required: true
        },
        stripeAccount: {
            type: String,
            required: true
        },
        subsidiary: {
            type: Object,
            required: true
        },
        formUrl: {
            type: String,
            required: true
        }
    },

    data () {
        return {
            stripe: null,
            newPaymentMethod: null,
            showSepa: false,
            showCard: false,
            submitActive: true
        }
    },

    computed: {
        sepaIcon () {
            return this.showSepa ? "fal fa-angle-up" : "fal fa-angle-down"
        },
        cardIcon () {
            return this.showCard ? "fal fa-angle-up" : "fal fa-angle-down"
        }
    },

    methods: {
        setNewPaymentMethodAsDefault (result) {
            this.newPaymentMethod = result.setupIntent.payment_method
            this.submitActive = false
            this.$http.post (this.formUrl, {
                _token: this.$csrf_token,
                payment_method: result.setupIntent.payment_method
            })
                .then (result => {
                    location.reload ()
                })
                .catch (error => {
                    this.$notify.error ({
                        title: "Karte nicht aktiviert",
                        text: error.response.data.message
                    })
                    this.submitActive = true
                })
        }
    },

    mounted () {
        //todo wo bekomme ich den stripe account her?
        this.stripe = Stripe (this.$pvPublicKey, {
            stripeAccount: this.stripeAccount
        })
    }
}
</script>

<style scoped lang="scss">
h5 {
    width: 100%;
    cursor: pointer;
}
</style>
